import { render, staticRenderFns } from "./AlbumInfoModal.vue?vue&type=template&id=7cb72698&"
import script from "./AlbumInfoModal.vue?vue&type=script&lang=js&"
export * from "./AlbumInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports